import React from "react";
import { DateRangePicker } from "react-date-range";
import {
  Button,
  Popover,
  RaisedButton,
  RadioButtonGroup,
  RadioButton,
  Toggle,
} from "material-ui";
import ArrowDropDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import moment from "moment-timezone";
import {
  defaultStaticRanges,
  createStaticRanges
} from "react-date-range/dist/defaultRanges";

import UserStore from "../../stores/UserStore";

class AnalyticsFilterWidget extends React.Component {

  // TO-DO:
  // Convert the Segment Filters to simple dropdowns or to a newer MaterialUI component.
  // Then we can reuse the component rather than duplicating.
  constructor(props) {
    super(props);

    this.state = {
      showRangeCalendar: false,
      allTime: false,
      range: {
        key: "selection",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
      },
      filterState: false,
      filter2State: false,
      useLedger: false,
      genericToggleOn: false,
      popoverOpen: false,
      anchorEl: null,
      popover2Open: false,
      anchorEl2: null,
    };

    this.onDateRangeChange = this.onDateRangeChange.bind(this);
    this.onLedgerToggleChange = this.onLedgerToggleChange.bind(this);
    this.handleLedgerToggleChange = this.handleLedgerToggleChange.bind(this);
    this.handleSegmentFilter = this.handleSegmentFilter.bind(this);
    this.onClickPopover = this.onClickPopover.bind(this);
    this.onClosePopover = this.onClosePopover.bind(this);
    this.buildSegmentFilterButtonLabel = this.buildSegmentFilterButtonLabel.bind(this);
    this.handleSegmentFilter2 = this.handleSegmentFilter2.bind(this);
    this.onClickPopover2 = this.onClickPopover2.bind(this);
    this.onClosePopover2 = this.onClosePopover2.bind(this);
    this.buildSegmentFilter2ButtonLabel = this.buildSegmentFilter2ButtonLabel.bind(this);
  }

  componentDidMount(props) {
    // Set selected radio buttons
    if (this.state.filterState === false) {
      this.setState({
        filterState: this.props.segmentFilterSelected
          ? this.props.segmentFilterSelected
          : null,
      })
    }
    if (this.state.filter2State === false) {
      this.setState({
        filter2State: this.props.segmentFilter2Selected
          ? this.props.segmentFilter2Selected
          : null,
      })
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.segmentFilterSelected !== this.state.filterState) {
      this.setState({ filterState: newProps.segmentFilterSelected })
    }
    if (newProps.segmentFilter2Selected !== this.state.filter2State) {
      this.setState({ filter2State: newProps.segmentFilter2Selected })
    }
  }

  onClickPopover(e) {
    e.preventDefault();

    this.setState({
      popoverOpen: true,
      anchorEl: e.currentTarget
    });
  }

  onClosePopover() {
    this.setState({ popoverOpen: false });
  }

  onClickPopover2(e) {
    e.preventDefault();

    this.setState({
      popover2Open: true,
      anchorEl2: e.currentTarget
    });
  }

  onClosePopover2() {
    this.setState({ popover2Open: false });
  }

  onDateRangeChange = (props) => {
    this.props.onDateRangeChange({
      range: this.state.range,
      allTime: this.state.allTime
    })
  }

  onSegmentFilterChange = (props) => {
    this.props.onSegmentFilterChange(this.state.filterState)
  }

  onSegmentFilter2Change = (props) => {
    this.props.onSegmentFilter2Change(this.state.filter2State)
  }

  onLedgerToggleChange = (props) => {
    this.props.onLedgerToggleChange(this.state.useLedger)
  }

  handleLedgerToggleChange = () => {
    this.setState({ useLedger: !this.state.useLedger },
      this.onLedgerToggleChange
    )
  }

  onGenericToggleChange = (props) => {
    this.props.onGenericToggleChange(this.state.genericToggleOn)
  }

  handleGenericToggleChange = () => {
    this.setState({ genericToggleOn: !this.state.genericToggleOn },
      this.onGenericToggleChange
    )
  }

  handleSegmentFilter(e) {
    this.setState(
      { filterState: e.target.value },
      this.onSegmentFilterChange
    )
  }

  handleSegmentFilter2(e) {
    this.setState(
      { filter2State: e.target.value },
      this.onSegmentFilter2Change
    )
  }

  onDateChange = ({ selection }) => {
    const allRange = {
      key: "selection",
    };
    const setTimeToEndOfDay = dateObj => {
      const obj = { ...dateObj }
      obj.endDate.setHours(23, 59, 59, 0)
      return obj
    }
    if (selection.startDate === "all_time") {
      this.setState(
        { allTime: true, showRangeEditor: false },
        this.onDateRangeChange
      );
      return;
    } else {
      this.setState({
        range: setTimeToEndOfDay(selection),
        allTime: false
      }, this.onDateRangeChange)
    }
  }

  buildSegmentFilterButtonLabel = () => {
    const segmentLabel =
      this.props.showSegmentFilter && this.props.segmentFilterConfig
        ? this.props.segmentFilterConfig.filter(
          s => s.value === this.props.segmentFilterSelected
        )
        : null
    if (!segmentLabel || segmentLabel.length < 1) {
      console.warn(`Warning: segmentFilterSelected is not valid.`);
    }
    return segmentLabel && segmentLabel[0] && segmentLabel[0].label
      ? segmentLabel[0].label
      : "Filter"
  }

  buildSegmentFilter2ButtonLabel = () => {
    const segmentLabel =
      this.props.showSegmentFilter2 && this.props.segmentFilter2Config
        ? this.props.segmentFilter2Config.filter(
          s => s.value === this.props.segmentFilter2Selected
        )
        : null
    if (!segmentLabel || segmentLabel.length < 1) {
      console.warn(`Warning: segmentFilter2Selected is not valid.`);
    }
    return segmentLabel && segmentLabel[0] && segmentLabel[0].label
      ? segmentLabel[0].label
      : "Filter"
  }

  getStyles() {
    return {
      rangeContainer: {
        marginBottom: "0",
        paddingBottom: "0.25rem"
      },
      rangeButton: {
        display: "inline-block",
        borderRadius: 20,
        padding: "8px 16px",
        fontSize: "12pt",
        color: "rgb(33,33,33)",
        cursor: "pointer",
        boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.1)",
        transition: "0.1s ease-in-out",
        ":hover": {
          boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.2)"
        }
      },
      overlay: {
        borderTop: "1px solid #dddddd",
        position: "absolute",
        left: 0,
        top: 0,
        backgroundColor: "#fff",
        boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
        zIndex: 1000
      },
      overlaySubmit: {
        position: "absolute",
        right: 10,
        bottom: 10
      }
    };
  }

  render() {
    const styles = this.getStyles();
    const browserTimezone = moment.tz(moment.tz.guess()).format('z');

    const DateFilter = () => {
      const dateFilterTitle = this.props.dateFilterToggleTitle ? `${this.props.dateFilterToggleTitle}` : `Filter by date`;

      return (
        <div className="filter-widget-item item-segment-filter first">
          <div
            className="date-filter"
            style={styles.rangeContainer}
            ref={r => { this.rangeButton = r; }}
          >
            <div className="filter-widget-item-title">
              {dateFilterTitle} <em>({browserTimezone})</em>
            </div>
            <RaisedButton
              onClick={() => this.setState({ showRangeCalendar: true })}
              label={
                this.state.allTime
                  ? "All time — click to filter"
                  : `${moment(this.state.range.startDate).format(
                    "ll"
                  )} – ${moment(this.state.range.endDate).format("ll")}`
              }
            />
            <div style={{ position: "absolute" }}>
              {this.state.showRangeCalendar ? (
                <div
                  style={styles.overlay}
                  ref={r => { this.container = r; }}
                >
                  <DateRangePicker
                    ranges={[this.state.range]}
                    showSelectionPreview={false}
                    onChange={this.onDateChange}
                    maxDate={new Date()}
                    shownDate={new Date(this.state.range.endDate)}
                    onHover={null}
                    staticRanges={[
                      {
                        label: "All Time",
                        isSelected: () => false,
                        range: () => {
                          return {
                            startDate: "all_time",
                            endDate: "all_time"
                          };
                        }
                      }
                    ].concat(defaultStaticRanges)}
                  />
                  <div style={styles.overlaySubmit}>
                    <RaisedButton
                      label="Close"
                      onTouchTap={
                        () => this.setState({ showRangeCalendar: false })
                      }
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )
    }

    const SegmentFilter = () => {
      return (
        <RadioButtonGroup
          name="event-filter"
          onChange={this.handleSegmentFilter}
          valueSelected={this.state.filterState}
        >
          {this.props.segmentFilterConfig.map(item => {
            return (
              <RadioButton
                className="filter-widget-radio"
                style={{ whiteSpace: "nowrap" }}
                key={item.value}
                value={item.value}
                label={item.label}
              />
            )
          })}
        </RadioButtonGroup>
      )
    }

    const SegmentFilter2 = () => {
      return (
        <RadioButtonGroup
          name="event-filter"
          onChange={this.handleSegmentFilter2}
          valueSelected={this.state.filter2State}
        >
          {this.props.segmentFilter2Config.map(item => {
            return (
              <RadioButton
                className="filter-widget-radio"
                style={{ whiteSpace: "nowrap" }}
                key={item.value}
                value={item.value}
                label={item.label}
              />
            )
          })}
        </RadioButtonGroup>
      )
    }

    const LedgerToggle = () => {
      const widgetClass = this.props.showSegmentFilter
        || this.props.showDateFilter
        ? "filter-widget-item item-ledger-toggle"
        : "filter-widget-item item-ledger-toggle first";
      return (
        <div className={widgetClass}>
          <div className="filter-widget-item-title">
            {this.props.ledgerToggleTitle
              ? this.props.ledgerToggleTitle
              : "Ledger data"
            }
          </div>
          <Toggle
            label="Use Ledger Data"
            data-toggled={this.state.useLedger}
            toggled={this.state.useLedger}
            style={{ display: "inline-block", width: 150, float: "left" }}
            onToggle={this.handleLedgerToggleChange}
            name="ledgerToggle"
          />
        </div>
      )
    }

    const GenericToggle = () => {
      const widgetClass =
        this.props.showSegmentFilter
          || this.props.showLedgerToggle
          && UserStore.isGod()
          || this.props.showDateFilter
          ? "filter-widget-item item-ledger-toggle"
          : "filter-widget-item item-ledger-toggle first";
      return (
        <div className={widgetClass}>
          <div className="filter-widget-item-title">
            {this.props.genericToggleTitle
              ? this.props.genericToggleTitle
              : "Data Toggle"
            }
          </div>
          <Toggle
            label={this.props.genericToggleLabel
              ? this.props.genericToggleLabel
              : null
            }
            data-toggled={this.state.genericToggleOn}
            toggled={this.state.genericToggleOn}
            style={{ display: "inline-block", width: 150, float: "left" }}
            onToggle={this.handleGenericToggleChange}
            name="genericToggle"
          />
        </div>
      )
    }

    return (
      <div className="filter-widget-container">
        {
          // DATE FILTER
          this.props.showDateFilter ? <DateFilter /> : null
        }
        {
          // SEGMENT FILTER
          this.props.showSegmentFilter
            ? (
              <div className={this.props.showDateFilter ? "filter-widget-item" : "filter-widget-item first"}>
                <div className="segment-filter">
                  <div className="filter-widget-item-title">
                    {this.props.segmentFilterTitle
                      ? this.props.segmentFilterTitle
                      : "Segment by"
                    }
                  </div>
                  <RaisedButton
                    label={this.buildSegmentFilterButtonLabel()}
                    onTouchTap={this.onClickPopover}
                    icon={<ArrowDropDown viewBox='5 4 10 20' />}
                    labelPosition="before"
                  />
                  <Popover
                    open={this.state.popoverOpen}
                    anchorEl={this.state.anchorEl}
                    onRequestClose={this.onClosePopover}
                    className="segmentedFilterPopover"
                  >
                    <SegmentFilter />
                  </Popover>
                </div>
              </div>
            ) : (null)
        }
        {
          // SEGMENT FILTER 2
          this.props.showSegmentFilter2
            ? (
              <div className={this.props.showDateFilter || this.props.showSegmentFilter ? "filter-widget-item" : "filter-widget-item first"}>
                <div className="segment-filter">
                  <div className="filter-widget-item-title">
                    {this.props.segmentFilter2Title
                      ? this.props.segmentFilter2Title
                      : "Segment by"
                    }
                  </div>
                  <RaisedButton
                    label={this.buildSegmentFilter2ButtonLabel()}
                    onTouchTap={this.onClickPopover2}
                    icon={<ArrowDropDown viewBox='5 4 10 20' />}
                    labelPosition="before"
                  />
                  <Popover
                    open={this.state.popover2Open}
                    anchorEl={this.state.anchorEl2}
                    onRequestClose={this.onClosePopover2}
                    className="segmentedFilter2Popover"
                  >
                    <SegmentFilter2 />
                  </Popover>
                </div>
              </div>
            ) : (null)
        }
        {
          // LEDGER TOGGLE
          this.props.showLedgerToggle
            && UserStore.isGod()
            ? <LedgerToggle />
            : null
        }
        {
          // GENERIC TOGGLE
          this.props.showGenericToggle
            ? <GenericToggle />
            : null
        }

        <div className="clear-both"></div>

      </div>
    )
  }
}
export default AnalyticsFilterWidget;



// WEBPACK FOOTER //
// ./src/app/components/partials/analytics-filter-widget.jsx